import * as React from "react";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import Paper from "material-ui/Paper";
import { Row, Col } from "react-flexbox-grid";
import { BusyEvent } from "../../../models/enums";
import Busy from "../../widgets/busy";
import { ILocalization } from "../../../models/localization";
import * as s from "./actions.css";

@inject("store") @observer
export class EditProfileAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if (!local) {
      return null;
    }
    // note, this is the edit profile card - clicking on it will tak user
    return (<Paper elevation={1} className={s.box}>
              <div onClick={() => hashHistory.push("/profile/about-me")} className={s.clickableBox} >
                <Row middle="xs" className={s.contentRow}>
                  <Col xs={4} sm={5}> <img src={local.icons.editProfile} className={s.icons} /></Col>
                  <Col xs={8} sm={7}> <p>{local.editProfile}</p></Col>
                </Row>
              </div>
            </Paper>);
  }
}

@inject("store") @observer
export class UploadResumeAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if (!local) {
      return null;
    }
    // Needs to be language specific action to take user to resume upload workflow
    return (<Paper elevation={1} className={s.box} >
            <div onClick={() => hashHistory.push("/profile/resume-import")} className={s.clickableBox} >
        <Row middle="xs" className={s.contentRow}>
          <Col xs={4} sm={5}><img src={this.props.store.profileStore.profile.resumeUpload ? local.icons.confirmUpload : local.icons.noUpload} className={s.icons} /></Col>
                <Col xs={8} sm={7}>
            <p className={s.uploadButton}>{local.uploadResume}</p>
            {this.props.store.profileStore.profile.resumeUpload && <p className={s.uploadText}>{local.resume.lastUploaded}: {this.props.store.profileStore.profile.resumeUpload.toLocaleDateString()}</p>}
                </Col>
              </Row>
            </div>
          </Paper>);
  }
}

@inject("store") @observer
export class AddExperienceAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }
  render(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    if (!local) {
      return null;
    }
    return (<Paper elevation={1} className={s.box}>
      <div onClick={() => hashHistory.push("/profile/add-experience")} className={s.clickableBox}>
      <Row>
        <Col xs={12}>
          <h5 className={s.blueHeader}>{local.addExp}</h5>
        </Col>
      </Row>
      <Row>
          <Col xsOffset={4} xs={4}>
            <img className={s.ppIcon} src={local.icons.addExperience} />
        </Col>
      </Row>
      <Row>
        <Col xsOffset={1} xs={10}>
          <p className={s.ppText}>{local.addExpDetail}</p>
        </Col>
      </Row>
        </div>
    </Paper>);
  }
}

@inject("store") @observer
export class DownloadPdfAction extends React.Component<{ store: SeekerStore }, {}> {
  constructor(props: any) {
    super(props);
  }

  renderBtnDisabled(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div>
        <Row middle="xs" className={s.contentRow}>
        <Col xs={4} sm={5}><img src={local.icons.personalProfile} className={s.disabledIcons} /></Col>
        <Col xs={8} sm={7}> <p className={s.disabledText}>{local.genPersonalProfile}</p></Col>
        </Row>
      </div>);
  }

  renderBtnEnabled(): JSX.Element {
    const local: ILocalization = this.props.store.localization.fields;
    return (<div className={s.clickableBox} onClick={this.props.store.profileStore.getNonOpProfile}>
      <Row middle="xs" className={s.contentRow}>
        <Col xs={4} sm={5}><img src={local.icons.personalProfile} className={s.icons} /></Col>
        <Col xs={8} sm={7}><p>{local.genPersonalProfile}</p></Col>
        </Row>
      </div>);
  }

  render(): JSX.Element {
    return (
      <Paper elevation={1} className={s.box} >
      {this.props.store.profileStore.profile.skills.length > 0 && this.renderBtnEnabled()}
      {this.props.store.profileStore.profile.skills.length === 0 && this.renderBtnDisabled()}
      </Paper>
   );
  }
}


// WEBPACK FOOTER //
// ./src/components/profile/actions/index.tsx